import { defineMessages } from 'react-intl';

export default defineMessages({
    wizardFnolLossDetailsTitle: {
        id: 'anonymous.wizard.fnol.pages.loss-details.Loss Details',
        defaultMessage: 'Loss details'
    }
});
